import { createApi } from "@reduxjs/toolkit/query/react";

import Tabprum from "../models/order/tabprum.model";
import dynamicBaseQuery from "./dynamicBaseQuery";

export const tabprumApi = createApi({
  reducerPath: "tabprumApi",
  tagTypes: ["Tabprum"],
  refetchOnMountOrArgChange: true,
  baseQuery: dynamicBaseQuery,
  endpoints: (builder) => ({
    getTabprum: builder.query<Tabprum[], void>({
      query: () => ({
        url: "/tabprum",
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
      providesTags: ["Tabprum"],
    }),
  }),
});

export const { useGetTabprumQuery } = tabprumApi;
